import { Dialog, DialogContent, DialogTitle } from '@mui/material'
import moment from 'moment'
import React from 'react'
import { Link } from 'react-router-dom'

function GrievanceListDialog({grievanceList,dialogStatus,setDialogStatus,getMasterLabel}) {
  return (
        <Dialog
            open={dialogStatus}
            keepMounted
            onClose={()=>setDialogStatus(false)}
            maxWidth="md"
            fullWidth={true}
        >
            <DialogTitle>Grievance List </DialogTitle>
            <DialogContent>
                <table className='table table-striped table-bordered'>
                    <thead>
                        <tr>
                            <th>Grievance ID</th>
                            <th>Complaint Type</th>
                            <th>Complainant Name</th>
                            <th>Complainant Phone</th>
                            <th>Complainant Date</th>
                            <th>Days</th>
                        </tr>
                    </thead>
                    <tbody>
                        {grievanceList && grievanceList.map(grievance=>
                            <tr key={grievance.id}>
                                <td><Link target="_blank" to={"/grievance/details/"+grievance.id} > {grievance.id} </Link></td>
                                <td>{getMasterLabel('grievance-type',grievance.grievanceType)}</td>
                                <td>{grievance.complainantName}</td>
                                <td>{grievance.phone}</td>
                                <td>{grievance.created_at}</td>
                                <td>{ moment().diff(moment(grievance.created_at),'days')} </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </DialogContent>
        </Dialog>
  	)
}

export default GrievanceListDialog